<div class="cancel-session-dialog font-name">
  <div class="dialog-header">
    <h3>Confirm Session Cancellation</h3>
    <i class="bi bi-x-lg close-icon" (click)="close()"></i>
  </div>

  <div class="dialog-scroll-content">
    <p class="subtitle">
      Please let us know why you're cancelling this session with
      <strong>{{ mentorName }}</strong
      >.
    </p>

    <div class="session-box">
      <span class="session-title">{{ sessionType }}</span>
      <span class="session-time">
        {{ sessionStartTime | date: "MMM d, y" }} , from
        {{ sessionStartTime | istUtcDate }} - {{ sessionEndTime | istUtcDate }}
      </span>
    </div>

    <div class="cancel-reason">
      <p>
        <span class="note">Note :</span> If the session is cancelled within
        <span class="note">12 hours</span> of the scheduled start time,
        <span class="note">no refund </span> will be provided as per our
        cancellation policy.
      </p>
    </div>

    <form [formGroup]="cancelForm">
      <label class="reason-label">Reason for Cancellation</label>
      <div class="reasons">
        <mat-radio-group
          formControlName="cancel_reason"
          (change)="onReasonChange($event)"
        >
          <mat-radio-button value="Schedule conflict"
            >Schedule conflict</mat-radio-button
          >
          <mat-radio-button value="Personal emergency"
            >Personal emergency</mat-radio-button
          >
          <mat-radio-button value="Found another mentor"
            >Found another mentor</mat-radio-button
          >
          <mat-radio-button value="No longer need the session"
            >No longer need the session</mat-radio-button
          >
          <mat-radio-button value="Other"
            >Other (please specify)</mat-radio-button
          >
        </mat-radio-group>
      </div>

      <div class="other-input" *ngIf="showOtherInput">
        <textarea
          formControlName="otherReason"
          placeholder="Please provide more details..."
          rows="3"
        ></textarea>
      </div>
    </form>
  </div>

  <div class="btn-group">
    <button class="btn-back" (click)="close()">Keep Session</button>
    <button
      class="btn-cancel"
      (click)="cancelSession()"
      [disabled]="cancelForm.invalid"
    >
      Continue to Cancel
    </button>
  </div>
</div>
